export const generateTempId = () => {
  return `temp-${Math.round(Math.random() * 100000000)}`;
}